// extracted by mini-css-extract-plugin
export var articleLifups = "articleLiftups-module--articleLifups--HhSXj";
export var largeLiftup = "articleLiftups-module--largeLiftup--mU39U";